module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/constructor-small.8026cd2f0b62d2dc7c9f8e91ec6b927d.jpg";